import React, { useState } from "react";

const API_BASE_URL = "https://last-resort-api.azurewebsites.net";

function getEmptyBeerForm() {
  return {
    Name: "",
    Subtitle: "",
    BeerColor: "#d9a13b",
    FoamColor: "#fff2cf",
    AnimatedBubbles: true,
    Description: "",
    ABV: "",
    Price: "",
    DisplayOrder: "",
    IsAvailable: true,
  };
}

function getEmptyDrinkForm() {
  return {
    DrinkName: "",
    DrinkType: "",
    Description: "",
    Price: "",
    ImageUrl: "",
    IconType: "",
    DisplayOrder: "",
    IsVisible: true,
  };
}

function getEmptyStaffForm() {
  return {
    StaffName: "",
    JobTitle: "",
    ImageUrl: "",
    Bio: "",
    Likes: "",
    FunFact: "",
    DisplayOrder: "",
    IsVisible: true,
  };
}

function getReadableError(value) {
  if (!value) {
    return "Something went wrong.";
  }

  if (typeof value === "string") {
    return value;
  }

  if (Array.isArray(value)) {
    return value
      .map((item) => {
        if (typeof item === "string") {
          return item;
        }

        const location = item.loc ? item.loc.join(" → ") : "unknown field";
        const message = item.msg || JSON.stringify(item);

        return `${location}: ${message}`;
      })
      .join("\n");
  }

  if (typeof value === "object") {
    if (value.detail) {
      return getReadableError(value.detail);
    }

    if (value.message) {
      return getReadableError(value.message);
    }

    if (value.error) {
      return getReadableError(value.error);
    }

    return JSON.stringify(value, null, 2);
  }

  return String(value);
}

async function readApiResponse(response) {
  const responseText = await response.text();

  if (!responseText) {
    return {};
  }

  try {
    return JSON.parse(responseText);
  } catch {
    return {
      message: responseText,
    };
  }
}

function isPublishedValue(value) {
  return (
    value === true ||
    value === 1 ||
    value === "1" ||
    value === "True" ||
    value === "true"
  );
}

function cleanAdminValue(value) {
  if (
    value === null ||
    value === undefined ||
    value === "None" ||
    value === "NaT" ||
    value === "nan" ||
    value === "NaN"
  ) {
    return "";
  }

  return value;
}

function AdminPage() {
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("lastResortAdminToken") ? true : false
  );

  const [password, setPassword] = useState("");
  const [activeSection, setActiveSection] = useState("dashboard");

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const [events, setEvents] = useState([]);

  const [editingEventId, setEditingEventId] = useState(null);

  const [beers, setBeers] = useState([]);
  const [editingBeerId, setEditingBeerId] = useState(null);

  const [drinks, setDrinks] = useState([]);
  const [drinkCategories, setDrinkCategories] = useState([]);
  const [editingDrinkId, setEditingDrinkId] = useState(null);

  const [staffMembers, setStaffMembers] = useState([]);
  const [editingStaffId, setEditingStaffId] = useState(null);

  const [bookings, setBookings] = useState([]);
  const [bookingSearch, setBookingSearch] = useState("");



  const [eventForm, setEventForm] = useState({
    EventTitle: "",
    EventDescription: "",
    EventDate: "",
    StartTime: "",
    EndTime: "",
    ImageUrl: "",
    IsPublished: true,
    DisplayOrder: "",
  });

  const [beerForm, setBeerForm] = useState(getEmptyBeerForm());

  const [drinkForm, setDrinkForm] = useState(getEmptyDrinkForm());

  const [staffForm, setStaffForm] = useState(getEmptyStaffForm());

  async function handleLogin(e) {
    e.preventDefault();

    setMessage("");
    setError("");

    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          password: password,
        }),
      });

      const data = await readApiResponse(response);

      if (!response.ok) {
        throw new Error(getReadableError(data));
      }

      localStorage.setItem("lastResortAdminToken", data.token);
      setLoggedIn(true);
      setPassword("");
      setMessage("Logged in successfully.");
    } catch (err) {
      setError(getReadableError(err.message || err));
    }
  }

  function handleLogout() {
    localStorage.removeItem("lastResortAdminToken");
    setLoggedIn(false);
    setActiveSection("dashboard");
    setMessage("");
    setError("");
    setEvents([]);
  }

    function goToSection(sectionName) {
    setActiveSection(sectionName);
    setMessage("");
    setError("");

    if (sectionName === "events") {
        loadEvents();
    }

    if (sectionName === "beers") {
        loadBeers();
    }

    if (sectionName === "drinks") {
        loadDrinkCategories();
        loadDrinks();
    }

    if (sectionName === "staff") {
        loadStaffMembers();
    }

    if (sectionName === "bookings") {
        loadBookings();
    }
    }

  function handleEventInputChange(e) {
    const { name, value } = e.target;

    setEventForm((currentForm) => ({
      ...currentForm,
      [name]: value,
    }));
  }

  async function loadEvents() {
    setError("");

    const token = localStorage.getItem("lastResortAdminToken");

    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/events`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await readApiResponse(response);

      if (!response.ok) {
        throw new Error(getReadableError(data));
      }

      setEvents(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(getReadableError(err.message || err));
    }
  }

  async function handleAddEvent(e) {
    e.preventDefault();

    setMessage("");
    setError("");

    const token = localStorage.getItem("lastResortAdminToken");

    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/events`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(eventForm),
      });

      const data = await readApiResponse(response);

      if (!response.ok) {
        throw new Error(getReadableError(data));
      }

      setMessage(data.message || "Event added successfully.");

      setEventForm({
        EventTitle: "",
        EventDescription: "",
        EventDate: "",
        StartTime: "",
        EndTime: "",
        ImageUrl: "",
        IsPublished: true,
        DisplayOrder: "",
      });

      await loadEvents();
    } catch (err) {
      setError(getReadableError(err.message || err));
    }
  }

  async function handleUpdateEvent(e) {
  e.preventDefault();

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  const updatedEvent = {
    EventID: editingEventId,
    EventTitle: eventForm.EventTitle,
    EventDescription: eventForm.EventDescription,
    EventDate: eventForm.EventDate,
    StartTime: eventForm.StartTime,
    EndTime: eventForm.EndTime,
    ImageUrl: eventForm.ImageUrl,
    IsPublished: eventForm.IsPublished,
    DisplayOrder: eventForm.DisplayOrder || 1,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/events`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedEvent),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Event updated successfully.");

    setEditingEventId(null);

    setEventForm({
      EventTitle: "",
      EventDescription: "",
      EventDate: "",
      StartTime: "",
      EndTime: "",
      ImageUrl: "",
      IsPublished: true,
      DisplayOrder: "",
    });

    await loadEvents();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

  function handleStartEdit(eventItem) {
  setEditingEventId(eventItem.EventID);

  setEventForm({
    EventTitle: cleanAdminValue(eventItem.EventTitle),
    EventDescription: cleanAdminValue(eventItem.EventDescription),
    EventDate: cleanAdminValue(eventItem.EventDate),
    StartTime: cleanAdminValue(eventItem.StartTime),
    EndTime: cleanAdminValue(eventItem.EndTime),
    ImageUrl: cleanAdminValue(eventItem.ImageUrl),
    IsPublished: isPublishedValue(eventItem.IsPublished),
    DisplayOrder: cleanAdminValue(eventItem.DisplayOrder),
  });

  setMessage("");
  setError("");

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

function handleCancelEdit() {
  setEditingEventId(null);

  setEventForm({
    EventTitle: "",
    EventDescription: "",
    EventDate: "",
    StartTime: "",
    EndTime: "",
    ImageUrl: "",
    IsPublished: true,
    DisplayOrder: "",
  });

  setMessage("");
  setError("");
}

  async function handleDeleteEvent(eventItem) {
    const confirmed = window.confirm(
      `Delete this event?\n\n${eventItem.EventTitle}`
    );

    if (!confirmed) {
      return;
    }

    setMessage("");
    setError("");

    const token = localStorage.getItem("lastResortAdminToken");

    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/events`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          EventID: eventItem.EventID,
        }),
      });

      const data = await readApiResponse(response);

      if (!response.ok) {
        throw new Error(getReadableError(data));
      }

      setMessage(data.message || "Event deleted successfully.");
      await loadEvents();
    } catch (err) {
      setError(getReadableError(err.message || err));
    }
  }

    async function handleTogglePublished(eventItem) {
    setMessage("");
    setError("");

    const token = localStorage.getItem("lastResortAdminToken");
    const currentlyPublished = isPublishedValue(eventItem.IsPublished);

    const updatedEvent = {
        EventID: eventItem.EventID,
        EventTitle: cleanAdminValue(eventItem.EventTitle),
        EventDescription: cleanAdminValue(eventItem.EventDescription),
        EventDate: cleanAdminValue(eventItem.EventDate),
        StartTime: cleanAdminValue(eventItem.StartTime),
        EndTime: cleanAdminValue(eventItem.EndTime),
        ImageUrl: cleanAdminValue(eventItem.ImageUrl),
        IsPublished: !currentlyPublished,
        DisplayOrder: cleanAdminValue(eventItem.DisplayOrder) || 1,
    };

    try {
        const response = await fetch(`${API_BASE_URL}/api/admin/events`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(updatedEvent),
        });

        const data = await readApiResponse(response);

        console.log("Toggle published payload:", updatedEvent);
        console.log("Toggle published response:", data);

        if (!response.ok) {
        throw new Error(getReadableError(data));
        }

        setMessage(
        !currentlyPublished
            ? "Event published successfully."
            : "Event unpublished successfully."
        );

        await loadEvents();
    } catch (err) {
        console.error("Toggle published failed:", err);
        setError(getReadableError(err.message || err));
    }
    }

function handleBeerInputChange(e) {
  const { name, value } = e.target;

  setBeerForm((currentForm) => ({
    ...currentForm,
    [name]: value,
  }));
}

async function loadBeers() {
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/beers`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setBeers(Array.isArray(data) ? data : []);
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function handleAddBeer(e) {
  e.preventDefault();

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/beers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(beerForm),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Beer tap added successfully.");
    setBeerForm(getEmptyBeerForm());

    await loadBeers();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

function handleStartBeerEdit(beerItem) {
  setEditingBeerId(beerItem.BeerTapID);

  setBeerForm({
    Name: cleanAdminValue(beerItem.Name),
    Subtitle: cleanAdminValue(beerItem.Subtitle),
    BeerColor: cleanAdminValue(beerItem.BeerColor) || "#d9a13b",
    FoamColor: cleanAdminValue(beerItem.FoamColor) || "#fff2cf",
    AnimatedBubbles: isPublishedValue(beerItem.AnimatedBubbles),
    Description: cleanAdminValue(beerItem.Description),
    ABV: cleanAdminValue(beerItem.ABV),
    Price: cleanAdminValue(beerItem.Price),
    DisplayOrder: cleanAdminValue(beerItem.DisplayOrder),
    IsAvailable: isPublishedValue(beerItem.IsAvailable),
  });

  setMessage("");
  setError("");

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

function handleCancelBeerEdit() {
  setEditingBeerId(null);
  setBeerForm(getEmptyBeerForm());
  setMessage("");
  setError("");
}

async function handleUpdateBeer(e) {
  e.preventDefault();

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  const updatedBeer = {
    BeerTapID: editingBeerId,
    ...beerForm,
    DisplayOrder: beerForm.DisplayOrder || 1,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/beers`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedBeer),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Beer tap updated successfully.");

    setEditingBeerId(null);
    setBeerForm(getEmptyBeerForm());

    await loadBeers();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function handleDeleteBeer(beerItem) {
  const confirmed = window.confirm(`Delete this beer tap?\n\n${beerItem.Name}`);

  if (!confirmed) {
    return;
  }

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/beers`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        BeerTapID: beerItem.BeerTapID,
      }),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Beer tap deleted successfully.");
    await loadBeers();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function handleToggleBeerAvailable(beerItem) {
  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");
  const currentlyAvailable = isPublishedValue(beerItem.IsAvailable);

  const updatedBeer = {
    BeerTapID: beerItem.BeerTapID,
    Name: cleanAdminValue(beerItem.Name),
    Subtitle: cleanAdminValue(beerItem.Subtitle),
    BeerColor: cleanAdminValue(beerItem.BeerColor) || "#d9a13b",
    FoamColor: cleanAdminValue(beerItem.FoamColor) || "#fff2cf",
    AnimatedBubbles: isPublishedValue(beerItem.AnimatedBubbles),
    Description: cleanAdminValue(beerItem.Description),
    ABV: cleanAdminValue(beerItem.ABV),
    Price: cleanAdminValue(beerItem.Price),
    DisplayOrder: cleanAdminValue(beerItem.DisplayOrder) || 1,
    IsAvailable: !currentlyAvailable,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/beers`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedBeer),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(
      !currentlyAvailable
        ? "Beer tap marked as available."
        : "Beer tap marked as unavailable."
    );

    await loadBeers();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

function handleDrinkInputChange(e) {
  const { name, value } = e.target;

  setDrinkForm((currentForm) => ({
    ...currentForm,
    [name]: value,
  }));
}

function handleDrinkCategoryChange(e) {
  const selectedTitle = e.target.value;

  const selectedCategory = drinkCategories.find(
    (category) => category.Title === selectedTitle
  );

  setDrinkForm((currentForm) => ({
    ...currentForm,
    DrinkType: selectedTitle,
    IconType: selectedCategory ? cleanAdminValue(selectedCategory.IconType) : "",
  }));
}

async function loadDrinkCategories() {
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/drink-categories`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setDrinkCategories(Array.isArray(data) ? data : []);
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function loadDrinks() {
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/drinks`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setDrinks(Array.isArray(data) ? data : []);
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function handleAddDrink(e) {
  e.preventDefault();

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/drinks`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(drinkForm),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Drink added successfully.");
    setDrinkForm(getEmptyDrinkForm());

    await loadDrinks();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

function handleStartDrinkEdit(drinkItem) {
  setEditingDrinkId(drinkItem.DrinkID);

  setDrinkForm({
    DrinkName: cleanAdminValue(drinkItem.DrinkName),
    DrinkType: cleanAdminValue(drinkItem.DrinkType),
    Description: cleanAdminValue(drinkItem.Description),
    Price: cleanAdminValue(drinkItem.Price),
    ImageUrl: cleanAdminValue(drinkItem.ImageUrl),
    IconType: cleanAdminValue(drinkItem.IconType),
    DisplayOrder: cleanAdminValue(drinkItem.DisplayOrder),
    IsVisible: isPublishedValue(drinkItem.IsVisible),
  });

  setMessage("");
  setError("");

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

function handleCancelDrinkEdit() {
  setEditingDrinkId(null);
  setDrinkForm(getEmptyDrinkForm());
  setMessage("");
  setError("");
}

async function handleUpdateDrink(e) {
  e.preventDefault();

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  const updatedDrink = {
    DrinkID: editingDrinkId,
    ...drinkForm,
    DisplayOrder: drinkForm.DisplayOrder || 1,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/drinks`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedDrink),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Drink updated successfully.");

    setEditingDrinkId(null);
    setDrinkForm(getEmptyDrinkForm());

    await loadDrinks();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function handleDeleteDrink(drinkItem) {
  const confirmed = window.confirm(`Delete this drink?\n\n${drinkItem.DrinkName}`);

  if (!confirmed) {
    return;
  }

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/drinks`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        DrinkID: drinkItem.DrinkID,
      }),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Drink deleted successfully.");
    await loadDrinks();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function handleToggleDrinkVisible(drinkItem) {
  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");
  const currentlyVisible = isPublishedValue(drinkItem.IsVisible);

  const updatedDrink = {
    DrinkID: drinkItem.DrinkID,
    DrinkName: cleanAdminValue(drinkItem.DrinkName),
    DrinkType: cleanAdminValue(drinkItem.DrinkType),
    Description: cleanAdminValue(drinkItem.Description),
    Price: cleanAdminValue(drinkItem.Price),
    ImageUrl: cleanAdminValue(drinkItem.ImageUrl),
    IconType: cleanAdminValue(drinkItem.IconType),
    DisplayOrder: cleanAdminValue(drinkItem.DisplayOrder) || 1,
    IsVisible: !currentlyVisible,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/drinks`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedDrink),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(
      !currentlyVisible
        ? "Drink made visible successfully."
        : "Drink hidden successfully."
    );

    await loadDrinks();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

function handleStaffInputChange(e) {
  const { name, value } = e.target;

  setStaffForm((currentForm) => ({
    ...currentForm,
    [name]: value,
  }));
}

async function loadStaffMembers() {
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/staff`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setStaffMembers(Array.isArray(data) ? data : []);
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function loadBookings() {
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/bookings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setBookings(Array.isArray(data) ? data : []);
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function handleDeleteBooking(booking) {
  const confirmed = window.confirm(
    `Delete this booking?\n\nGuest: ${booking.GuestName}\nEvent: ${booking.EventName}`
  );

  if (!confirmed) {
    return;
  }

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/bookings`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        BookingID: booking.BookingID,
      }),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Booking deleted successfully.");
    await loadBookings();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function handleAddStaff(e) {
  e.preventDefault();

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/staff`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(staffForm),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Staff member added successfully.");
    setStaffForm(getEmptyStaffForm());

    await loadStaffMembers();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

function handleStartStaffEdit(staffItem) {
  setEditingStaffId(staffItem.StaffID);

  setStaffForm({
    StaffName: cleanAdminValue(staffItem.StaffName),
    JobTitle: cleanAdminValue(staffItem.JobTitle),
    ImageUrl: cleanAdminValue(staffItem.ImageUrl),
    Bio: cleanAdminValue(staffItem.Bio),
    Likes: cleanAdminValue(staffItem.Likes),
    FunFact: cleanAdminValue(staffItem.FunFact),
    DisplayOrder: cleanAdminValue(staffItem.DisplayOrder),
    IsVisible: isPublishedValue(staffItem.IsVisible),
  });

  setMessage("");
  setError("");

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

function handleCancelStaffEdit() {
  setEditingStaffId(null);
  setStaffForm(getEmptyStaffForm());
  setMessage("");
  setError("");
}

async function handleUpdateStaff(e) {
  e.preventDefault();

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  const updatedStaff = {
    StaffID: editingStaffId,
    ...staffForm,
    DisplayOrder: staffForm.DisplayOrder || 1,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/staff`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedStaff),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Staff member updated successfully.");

    setEditingStaffId(null);
    setStaffForm(getEmptyStaffForm());

    await loadStaffMembers();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function handleDeleteStaff(staffItem) {
  const confirmed = window.confirm(
    `Delete this staff member?\n\n${staffItem.StaffName}`
  );

  if (!confirmed) {
    return;
  }

  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/staff`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        StaffID: staffItem.StaffID,
      }),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(data.message || "Staff member deleted successfully.");
    await loadStaffMembers();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

async function handleToggleStaffVisible(staffItem) {
  setMessage("");
  setError("");

  const token = localStorage.getItem("lastResortAdminToken");
  const currentlyVisible = isPublishedValue(staffItem.IsVisible);

  const updatedStaff = {
    StaffID: staffItem.StaffID,
    StaffName: cleanAdminValue(staffItem.StaffName),
    JobTitle: cleanAdminValue(staffItem.JobTitle),
    ImageUrl: cleanAdminValue(staffItem.ImageUrl),
    Bio: cleanAdminValue(staffItem.Bio),
    Likes: cleanAdminValue(staffItem.Likes),
    FunFact: cleanAdminValue(staffItem.FunFact),
    DisplayOrder: cleanAdminValue(staffItem.DisplayOrder) || 1,
    IsVisible: !currentlyVisible,
  };

  try {
    const response = await fetch(`${API_BASE_URL}/api/admin/staff`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(updatedStaff),
    });

    const data = await readApiResponse(response);

    if (!response.ok) {
      throw new Error(getReadableError(data));
    }

    setMessage(
      !currentlyVisible
        ? "Staff member made visible successfully."
        : "Staff member hidden successfully."
    );

    await loadStaffMembers();
  } catch (err) {
    setError(getReadableError(err.message || err));
  }
}

  if (!loggedIn) {
    return (
      <main className="admin-page">
        <section className="admin-panel">
          <h1>Website Admin Panel</h1>
          <p>Log in to manage The Last Resort website content.</p>

          <form className="admin-form" onSubmit={handleLogin}>
            <label>
              Admin password
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </label>

            <button type="submit">Log in</button>
          </form>

          {message && <p className="admin-success">{message}</p>}
          {error && <pre className="admin-error">{error}</pre>}
        </section>
      </main>
    );
  }

  return (
    <main className="admin-page">
      <section className="admin-panel">
        <div className="admin-topbar">
          <div>
            <h1>Website Admin Panel</h1>
            <p>You are logged in. This is where the website content tools will go.</p>
          </div>

          <button type="button" onClick={handleLogout}>
            Log out
          </button>
        </div>

        {message && <p className="admin-success">{message}</p>}
        {error && <pre className="admin-error">{error}</pre>}

        {activeSection === "dashboard" && (
          <div className="admin-grid">
            <div className="admin-card">
              <h2>Events</h2>
              <p>Add, edit, publish, unpublish, or remove events.</p>
              <button type="button" onClick={() => goToSection("events")}>
                Manage Events
              </button>
            </div>

            <div className="admin-card">
              <h2>Beer Taps</h2>
              <p>Update the current tap selection shown on the website.</p>
              <button type="button" onClick={() => goToSection("beers")}>
                Manage Beers
              </button>
            </div>

            <div className="admin-card">
              <h2>Drinks</h2>
              <p>Edit the drinks carousel content.</p>
              <button type="button" onClick={() => goToSection("drinks")}>
                Manage Drinks
              </button>
            </div>

            <div className="admin-card">
              <h2>Staff</h2>
              <p>Update staff names, roles, bios, and fun facts.</p>
              <button type="button" onClick={() => goToSection("staff")}>
                Manage Staff
              </button>
            </div>

            <div className="admin-card">
              <h2>Bookings</h2>
              <p>View people who have signed up for events.</p>
              <button type="button" onClick={() => goToSection("bookings")}>
                View Bookings
              </button>
            </div>
          </div>
        )}

        {activeSection === "events" && (
          <section className="admin-section">
            <button type="button" onClick={() => goToSection("dashboard")}>
              Back to dashboard
            </button>

        <h2>{editingEventId ? "Edit Event" : "Manage Events"}</h2>
        <p>
        {editingEventId
            ? "Update the selected event."
            : "Add a new event to the website."}
        </p>

            <form
            className="admin-form"
            onSubmit={editingEventId ? handleUpdateEvent : handleAddEvent}
            >
              <label>
                Event title
                <input
                  type="text"
                  name="EventTitle"
                  value={eventForm.EventTitle}
                  onChange={handleEventInputChange}
                  required
                />
              </label>

              <label>
                Event description
                <textarea
                  name="EventDescription"
                  value={eventForm.EventDescription}
                  onChange={handleEventInputChange}
                  rows="4"
                />
              </label>

              <label>
                Event date
                <input
                  type="date"
                  name="EventDate"
                  value={eventForm.EventDate}
                  onChange={handleEventInputChange}
                />
              </label>

              <label>
                Start time
                <input
                  type="time"
                  name="StartTime"
                  value={eventForm.StartTime}
                  onChange={handleEventInputChange}
                />
              </label>

              <label>
                End time
                <input
                  type="time"
                  name="EndTime"
                  value={eventForm.EndTime}
                  onChange={handleEventInputChange}
                />
              </label>

              <label>
                Image URL
                <input
                  type="text"
                  name="ImageUrl"
                  value={eventForm.ImageUrl}
                  onChange={handleEventInputChange}
                  placeholder="assets/photo1.png"
                />
              </label>

              <label>
                Display order
                <input
                  type="number"
                  name="DisplayOrder"
                  value={eventForm.DisplayOrder}
                  onChange={handleEventInputChange}
                  placeholder="Leave blank to auto-order"
                />
              </label>

              <label>
                Published?
                <select
                  name="IsPublished"
                  value={eventForm.IsPublished ? "true" : "false"}
                  onChange={(e) =>
                    setEventForm((currentForm) => ({
                      ...currentForm,
                      IsPublished: e.target.value === "true",
                    }))
                  }
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </label>

                <button type="submit">
                {editingEventId ? "Save Event Changes" : "Add Event"}
                </button>
                {editingEventId && (
                <button type="button" onClick={handleCancelEdit}>
                    Cancel Edit
                </button>
                )}
            </form>

            <div className="admin-event-list">
              <div className="admin-list-header">
                <h3>Current Events</h3>

                <button type="button" onClick={loadEvents}>
                  Refresh Events
                </button>
              </div>

              {events.length === 0 ? (
                <p>No events found yet.</p>
              ) : (
                events.map((eventItem) => {
                  const published = isPublishedValue(eventItem.IsPublished);

                  return (
                    <article className="admin-list-item" key={eventItem.EventID}>
                      <div className="admin-list-item-top">
                        <div>
                          <h4>{eventItem.EventTitle}</h4>
                          <p>
                            <strong>Date:</strong>{" "}
                            {eventItem.EventDate || "No date"}
                          </p>
                          <p>
                            <strong>Time:</strong>{" "}
                            {eventItem.StartTime || "No start time"}
                            {eventItem.EndTime ? ` - ${eventItem.EndTime}` : ""}
                          </p>
                          <p>
                            <strong>Published:</strong>{" "}
                            {published ? "Yes" : "No"}
                          </p>
                          <p>
                            <strong>Display order:</strong>{" "}
                            {eventItem.DisplayOrder || "Not set"}
                          </p>
                        </div>

                        <div className="admin-list-actions">
                        <button type="button" onClick={() => handleStartEdit(eventItem)}>
                            Edit
                        </button>

                        <button
                            type="button"
                            onClick={() => handleTogglePublished(eventItem)}
                        >
                            {published ? "Unpublish" : "Publish"}
                        </button>

                        <button
                            type="button"
                            className="admin-danger-button"
                            onClick={() => handleDeleteEvent(eventItem)}
                        >
                            Delete
                        </button>
                        </div>
                      </div>

                      {eventItem.EventDescription && (
                        <p>{eventItem.EventDescription}</p>
                      )}

                      {eventItem.ImageUrl && (
                        <p>
                          <strong>Image:</strong> {eventItem.ImageUrl}
                        </p>
                      )}
                    </article>
                  );
                })
              )}
            </div>
          </section>
        )}

{activeSection === "beers" && (
  <section className="admin-section">
    <button type="button" onClick={() => goToSection("dashboard")}>
      Back to dashboard
    </button>

    <h2>{editingBeerId ? "Edit Beer Tap" : "Manage Beer Taps"}</h2>
    <p>
      {editingBeerId
        ? "Update the selected beer tap."
        : "Add, edit, remove, or hide beer taps."}
    </p>

    <form
      className="admin-form"
      onSubmit={editingBeerId ? handleUpdateBeer : handleAddBeer}
    >
      <label>
        Beer name
        <input
          type="text"
          name="Name"
          value={beerForm.Name}
          onChange={handleBeerInputChange}
          required
        />
      </label>

      <label>
        Subtitle
        <input
          type="text"
          name="Subtitle"
          value={beerForm.Subtitle}
          onChange={handleBeerInputChange}
          placeholder="Sunshine Lager"
        />
      </label>

      <label>
        Beer colour
        <input
          type="color"
          name="BeerColor"
          value={beerForm.BeerColor}
          onChange={handleBeerInputChange}
        />
      </label>

      <label>
        Foam colour
        <input
          type="color"
          name="FoamColor"
          value={beerForm.FoamColor}
          onChange={handleBeerInputChange}
        />
      </label>

      <label>
        Description
        <textarea
          name="Description"
          value={beerForm.Description}
          onChange={handleBeerInputChange}
          rows="4"
        />
      </label>

      <label>
        ABV
        <input
          type="text"
          name="ABV"
          value={beerForm.ABV}
          onChange={handleBeerInputChange}
          placeholder="4.2%"
        />
      </label>

      <label>
        Price
        <input
          type="text"
          name="Price"
          value={beerForm.Price}
          onChange={handleBeerInputChange}
          placeholder="£5.20"
        />
      </label>

      <label>
        Display order
        <input
          type="number"
          name="DisplayOrder"
          value={beerForm.DisplayOrder}
          onChange={handleBeerInputChange}
          placeholder="Leave blank to auto-order"
        />
      </label>

      <label>
        Animated bubbles?
        <select
          name="AnimatedBubbles"
          value={beerForm.AnimatedBubbles ? "true" : "false"}
          onChange={(e) =>
            setBeerForm((currentForm) => ({
              ...currentForm,
              AnimatedBubbles: e.target.value === "true",
            }))
          }
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </label>

      <label>
        Available?
        <select
          name="IsAvailable"
          value={beerForm.IsAvailable ? "true" : "false"}
          onChange={(e) =>
            setBeerForm((currentForm) => ({
              ...currentForm,
              IsAvailable: e.target.value === "true",
            }))
          }
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </label>

      <button type="submit">
        {editingBeerId ? "Save Beer Changes" : "Add Beer Tap"}
      </button>

      {editingBeerId && (
        <button type="button" onClick={handleCancelBeerEdit}>
          Cancel Edit
        </button>
      )}
    </form>

    <div className="admin-event-list">
      <div className="admin-list-header">
        <h3>Current Beer Taps</h3>

        <button type="button" onClick={loadBeers}>
          Refresh Beers
        </button>
      </div>

      {beers.length === 0 ? (
        <p>No beer taps found yet.</p>
      ) : (
        beers.map((beerItem) => {
          const available = isPublishedValue(beerItem.IsAvailable);
          const animated = isPublishedValue(beerItem.AnimatedBubbles);

          return (
            <article className="admin-list-item" key={beerItem.BeerTapID}>
              <div className="admin-list-item-top">
                <div>
                  <h4>{beerItem.Name}</h4>

                  <p>
                    <strong>Subtitle:</strong>{" "}
                    {beerItem.Subtitle || "No subtitle"}
                  </p>

                  <p>
                    <strong>ABV:</strong> {beerItem.ABV || "Not set"}
                  </p>

                  <p>
                    <strong>Price:</strong> {beerItem.Price || "Not set"}
                  </p>

                  <p>
                    <strong>Available:</strong> {available ? "Yes" : "No"}
                  </p>

                  <p>
                    <strong>Animated bubbles:</strong>{" "}
                    {animated ? "Yes" : "No"}
                  </p>

                  <p>
                    <strong>Display order:</strong>{" "}
                    {beerItem.DisplayOrder || "Not set"}
                  </p>

                  <p>
                    <strong>Beer colour:</strong>{" "}
                    <span
                      className="admin-colour-preview"
                      style={{ backgroundColor: beerItem.BeerColor }}
                    ></span>
                    {beerItem.BeerColor}
                  </p>

                  <p>
                    <strong>Foam colour:</strong>{" "}
                    <span
                      className="admin-colour-preview"
                      style={{ backgroundColor: beerItem.FoamColor }}
                    ></span>
                    {beerItem.FoamColor}
                  </p>
                </div>

                <div className="admin-list-actions">
                  <button
                    type="button"
                    onClick={() => handleStartBeerEdit(beerItem)}
                  >
                    Edit
                  </button>

                  <button
                    type="button"
                    onClick={() => handleToggleBeerAvailable(beerItem)}
                  >
                    {available ? "Mark Unavailable" : "Mark Available"}
                  </button>

                  <button
                    type="button"
                    className="admin-danger-button"
                    onClick={() => handleDeleteBeer(beerItem)}
                  >
                    Delete
                  </button>
                </div>
              </div>

              {beerItem.Description && <p>{beerItem.Description}</p>}
            </article>
          );
        })
      )}
    </div>
  </section>
)}
{activeSection === "drinks" && (
  <section className="admin-section">
    <button type="button" onClick={() => goToSection("dashboard")}>
      Back to dashboard
    </button>

    <h2>{editingDrinkId ? "Edit Drink" : "Manage Drinks"}</h2>
    <p>
      {editingDrinkId
        ? "Update the selected drink."
        : "Add, edit, remove, or hide drinks."}
    </p>

    <form
      className="admin-form"
      onSubmit={editingDrinkId ? handleUpdateDrink : handleAddDrink}
    >
      <label>
        Drink name
        <input
          type="text"
          name="DrinkName"
          value={drinkForm.DrinkName}
          onChange={handleDrinkInputChange}
          required
        />
      </label>

      <label>
        Category
        <select
          value={drinkForm.DrinkType}
          onChange={handleDrinkCategoryChange}
        >
          <option value="">Choose a category</option>
          {drinkCategories.map((category) => (
            <option key={category.DrinkCategoryID} value={category.Title}>
              {category.Title}
            </option>
          ))}
        </select>
      </label>

      <label>
        Drink type
        <input
          type="text"
          name="DrinkType"
          value={drinkForm.DrinkType}
          onChange={handleDrinkInputChange}
          placeholder="Soft Drink"
        />
      </label>

      <label>
        Icon type
        <input
          type="text"
          name="IconType"
          value={drinkForm.IconType}
          onChange={handleDrinkInputChange}
          placeholder="soft, bottle, wine, spirit"
        />
      </label>

      <label>
        Description
        <textarea
          name="Description"
          value={drinkForm.Description}
          onChange={handleDrinkInputChange}
          rows="4"
        />
      </label>

      <label>
        Price
        <input
          type="text"
          name="Price"
          value={drinkForm.Price}
          onChange={handleDrinkInputChange}
          placeholder="£4.50"
        />
      </label>

      <label>
        Image URL
        <input
          type="text"
          name="ImageUrl"
          value={drinkForm.ImageUrl}
          onChange={handleDrinkInputChange}
          placeholder="assets/drink.png"
        />
      </label>

      <label>
        Display order
        <input
          type="number"
          name="DisplayOrder"
          value={drinkForm.DisplayOrder}
          onChange={handleDrinkInputChange}
          placeholder="Leave blank to auto-order"
        />
      </label>

      <label>
        Visible?
        <select
          name="IsVisible"
          value={drinkForm.IsVisible ? "true" : "false"}
          onChange={(e) =>
            setDrinkForm((currentForm) => ({
              ...currentForm,
              IsVisible: e.target.value === "true",
            }))
          }
        >
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </label>

      <button type="submit">
        {editingDrinkId ? "Save Drink Changes" : "Add Drink"}
      </button>

      {editingDrinkId && (
        <button type="button" onClick={handleCancelDrinkEdit}>
          Cancel Edit
        </button>
      )}
    </form>

    <div className="admin-event-list">
      <div className="admin-list-header">
        <h3>Current Drinks</h3>

        <button type="button" onClick={loadDrinks}>
          Refresh Drinks
        </button>
      </div>

      {drinks.length === 0 ? (
        <p>No drinks found yet.</p>
      ) : (
        drinks.map((drinkItem) => {
          const visible = isPublishedValue(drinkItem.IsVisible);

          return (
            <article className="admin-list-item" key={drinkItem.DrinkID}>
              <div className="admin-list-item-top">
                <div>
                  <h4>{drinkItem.DrinkName}</h4>

                  <p>
                    <strong>Type:</strong>{" "}
                    {drinkItem.DrinkType || "Not set"}
                  </p>

                  <p>
                    <strong>Icon:</strong>{" "}
                    {drinkItem.IconType || "Not set"}
                  </p>

                  <p>
                    <strong>Price:</strong>{" "}
                    {drinkItem.Price || "Not set"}
                  </p>

                  <p>
                    <strong>Visible:</strong>{" "}
                    {visible ? "Yes" : "No"}
                  </p>

                  <p>
                    <strong>Display order:</strong>{" "}
                    {drinkItem.DisplayOrder || "Not set"}
                  </p>

                  {drinkItem.ImageUrl && (
                    <p>
                      <strong>Image:</strong> {drinkItem.ImageUrl}
                    </p>
                  )}
                </div>

                <div className="admin-list-actions">
                  <button
                    type="button"
                    onClick={() => handleStartDrinkEdit(drinkItem)}
                  >
                    Edit
                  </button>

                  <button
                    type="button"
                    onClick={() => handleToggleDrinkVisible(drinkItem)}
                  >
                    {visible ? "Hide" : "Show"}
                  </button>

                  <button
                    type="button"
                    className="admin-danger-button"
                    onClick={() => handleDeleteDrink(drinkItem)}
                  >
                    Delete
                  </button>
                </div>
              </div>

              {drinkItem.Description && <p>{drinkItem.Description}</p>}
            </article>
          );
        })
      )}
    </div>
  </section>
)}

        {activeSection === "staff" && (
          <section className="admin-section">
            <button type="button" onClick={() => goToSection("dashboard")}>
              Back to dashboard
            </button>

            <h2>{editingStaffId ? "Edit Staff Member" : "Manage Staff"}</h2>
            <p>
              {editingStaffId
                ? "Update the selected staff member."
                : "Add, edit, remove, or hide staff members."}
            </p>

            <form
              className="admin-form"
              onSubmit={editingStaffId ? handleUpdateStaff : handleAddStaff}
            >
              <label>
                Staff name
                <input
                  type="text"
                  name="StaffName"
                  value={staffForm.StaffName}
                  onChange={handleStaffInputChange}
                  required
                />
              </label>

              <label>
                Job title
                <input
                  type="text"
                  name="JobTitle"
                  value={staffForm.JobTitle}
                  onChange={handleStaffInputChange}
                  placeholder="Bar Staff"
                />
              </label>

              <label>
                Image URL
                <input
                  type="text"
                  name="ImageUrl"
                  value={staffForm.ImageUrl}
                  onChange={handleStaffInputChange}
                  placeholder="assets/Ben.png"
                />
              </label>

              <label>
                Bio
                <textarea
                  name="Bio"
                  value={staffForm.Bio}
                  onChange={handleStaffInputChange}
                  rows="4"
                />
              </label>

              <label>
                Likes
                <textarea
                  name="Likes"
                  value={staffForm.Likes}
                  onChange={handleStaffInputChange}
                  rows="3"
                />
              </label>

              <label>
                Fun fact
                <textarea
                  name="FunFact"
                  value={staffForm.FunFact}
                  onChange={handleStaffInputChange}
                  rows="3"
                />
              </label>

              <label>
                Display order
                <input
                  type="number"
                  name="DisplayOrder"
                  value={staffForm.DisplayOrder}
                  onChange={handleStaffInputChange}
                  placeholder="Leave blank to auto-order"
                />
              </label>

              <label>
                Visible?
                <select
                  name="IsVisible"
                  value={staffForm.IsVisible ? "true" : "false"}
                  onChange={(e) =>
                    setStaffForm((currentForm) => ({
                      ...currentForm,
                      IsVisible: e.target.value === "true",
                    }))
                  }
                >
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </label>

              <button type="submit">
                {editingStaffId ? "Save Staff Changes" : "Add Staff Member"}
              </button>

              {editingStaffId && (
                <button type="button" onClick={handleCancelStaffEdit}>
                  Cancel Edit
                </button>
              )}
            </form>

            <div className="admin-event-list">
              <div className="admin-list-header">
                <h3>Current Staff</h3>

                <button type="button" onClick={loadStaffMembers}>
                  Refresh Staff
                </button>
              </div>

              {staffMembers.length === 0 ? (
                <p>No staff members found yet.</p>
              ) : (
                staffMembers.map((staffItem) => {
                  const visible = isPublishedValue(staffItem.IsVisible);

                  return (
                    <article className="admin-list-item" key={staffItem.StaffID}>
                      <div className="admin-list-item-top">
                        <div>
                          <h4>{staffItem.StaffName}</h4>

                          <p>
                            <strong>Job title:</strong>{" "}
                            {staffItem.JobTitle || "Not set"}
                          </p>

                          <p>
                            <strong>Visible:</strong> {visible ? "Yes" : "No"}
                          </p>

                          <p>
                            <strong>Display order:</strong>{" "}
                            {staffItem.DisplayOrder || "Not set"}
                          </p>

                          {staffItem.ImageUrl && (
                            <p>
                              <strong>Image:</strong> {staffItem.ImageUrl}
                            </p>
                          )}
                        </div>

                        <div className="admin-list-actions">
                          <button
                            type="button"
                            onClick={() => handleStartStaffEdit(staffItem)}
                          >
                            Edit
                          </button>

                          <button
                            type="button"
                            onClick={() => handleToggleStaffVisible(staffItem)}
                          >
                            {visible ? "Hide" : "Show"}
                          </button>

                          <button
                            type="button"
                            className="admin-danger-button"
                            onClick={() => handleDeleteStaff(staffItem)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>

                      {staffItem.Bio && <p>{staffItem.Bio}</p>}

                      {staffItem.Likes && (
                        <p>
                          <strong>Likes:</strong> {staffItem.Likes}
                        </p>
                      )}

                      {staffItem.FunFact && (
                        <p>
                          <strong>Fun fact:</strong> {staffItem.FunFact}
                        </p>
                      )}
                    </article>
                  );
                })
              )}
            </div>
          </section>
        )}

        {activeSection === "bookings" && (
          <section className="admin-section">
            <button type="button" onClick={() => goToSection("dashboard")}>
              Back to dashboard
            </button>

            <div className="admin-list-header">
              <div>
                <h2>Event Bookings</h2>
                <p>View people who have signed up for events.</p>
              </div>

              <button type="button" onClick={loadBookings}>
                Refresh Bookings
              </button>
            </div>

            <label>
              Search bookings
              <input
                type="text"
                value={bookingSearch}
                onChange={(e) => setBookingSearch(e.target.value)}
                placeholder="Search by event, name, or email..."
              />
            </label>

            <div className="admin-event-list">
              {bookings.length === 0 ? (
                <p>No bookings found yet.</p>
              ) : (
                bookings
                  .filter((booking) => {
                    const search = bookingSearch.toLowerCase();

                    return (
                      String(booking.EventName || "")
                        .toLowerCase()
                        .includes(search) ||
                      String(booking.GuestName || "")
                        .toLowerCase()
                        .includes(search) ||
                      String(booking.Email || "")
                        .toLowerCase()
                        .includes(search)
                    );
                  })
                  .map((booking) => (
                    <article className="admin-list-item" key={booking.BookingID}>
                      <div className="admin-list-item-top">
                        <div>
                          <h4>{booking.EventName || "No event selected"}</h4>

                          <p>
                            <strong>Guest:</strong>{" "}
                            {booking.GuestName || "Not provided"}
                          </p>

                          <p>
                            <strong>Email:</strong>{" "}
                            {booking.Email ? (
                              <a href={`mailto:${booking.Email}`}>
                                {booking.Email}
                              </a>
                            ) : (
                              "No email"
                            )}
                          </p>

                          <p>
                            <strong>Attendees:</strong>{" "}
                            {booking.Attendees || "Not set"}
                          </p>

                          <p>
                            <strong>Status:</strong>{" "}
                            {booking.BookingStatus || "Not set"}
                          </p>

                          <p>
                            <strong>Created:</strong>{" "}
                            {booking.CreatedAt || "Not set"}
                          </p>

                          <button
                            type="button"
                            className="admin-danger-button"
                            onClick={() => handleDeleteBooking(booking)}
                          >
                            Delete Booking
                          </button>
                        </div>
                      </div>
                    </article>
                  ))
              )}
            </div>
          </section>
        )}
      </section>
    </main>
  );
}

export default AdminPage;
